import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScreenSizeDetectorService } from '@serviceplan/ui-kit';
import { CommonUtilityLib, PROMPTS, ViewType, anyAsset } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { AssetViewTypeService } from '../../services/asset-view-type.service';
import { MenuSettingsData } from './collection-asset-view/asset-view-actions/menu-settings-data';
import { CollectionEventsService } from './services/collection-events.service';

@Component({
  selector: 'thehubz-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss'],
})
export class CollectionComponent implements OnInit {
  @Input() gridSettingsKeySuffix = 'CollectionsOverview';
  navLinks: {
    path: string;
    label: string;
  }[] = [];
  currentTab = '';
  searchText = '';
  searchPlaceholder = PROMPTS.PLACEHOLDER.SEARCH;
  isMobileSearchOpen = false;
  AnyAsset = anyAsset;
  assetGalleryMenuObject = MenuSettingsData.ASSET_GALLERY_MENU_SETTINGS;
  selectedViewSection2: ViewType = 'sortByLastCreated';
  sortByNew = true;

  collectionsGalleryMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_GALLERY_MENU_SETTINGS);
  collectionsTableMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_TABLE_MENU_SETTINGS);
  tableData: AnyType;

  constructor(
    private commonUtilityLib: CommonUtilityLib,
    private activatedRoute: ActivatedRoute,
    private collectionEventsService: CollectionEventsService,
    protected assetViewTypeService: AssetViewTypeService,
    protected screenSizeDetectorService: ScreenSizeDetectorService,
  ) {}

  ngOnInit(): void {
    this.navLinks =
      this.activatedRoute.routeConfig && this.activatedRoute.routeConfig.children
        ? this.commonUtilityLib.buildNavItems(this.activatedRoute.routeConfig.children)
        : [];
    this.collectionEventsService.collectionsClearSearch.subscribe((data) => {
      if (data) this.clearSearch('');
    });
    this.collectionEventsService.collectionsTableDataSubject$.subscribe((data) => {
      if (data) this.tableData = data;
    });
  }

  currentTabClick(path: string) {
    this.currentTab = path;
  }

  /**
   * SearchField methods
   */

  changeView(event: any) {
    this.collectionEventsService.collectionListChangeView.next(event);
  }

  sortBy(event: any) {
    this.sortByNew = !this.sortByNew;
    this.selectedViewSection2 = event;
    this.collectionEventsService.collectionListSortBy.next(event);
  }

  searchTextChanged(event: any) {
    this.searchText = event;
    this.collectionEventsService.collectionListSearchFilter$.next(event);
    if (!event.length) {
      this.collectionEventsService.collectionsSearchFilterBubbles$.next('');
    }
  }

  addOnEnter() {
    if (this.searchText) {
      this.collectionEventsService.collectionsSearchFilterBubbles$.next(this.searchText);
    }
  }

  clearSearch(event: any) {
    this.searchText = event;
    this.collectionEventsService.collectionListSearchFilter$.next(event);
    this.collectionEventsService.collectionsSearchFilterBubbles$.next(event);
  }

  toggleMobileSearch() {
    this.isMobileSearchOpen = !this.isMobileSearchOpen;
    if (this.isMobileSearchOpen) {
      document.querySelector('.actions-container')?.classList.remove('mb-8');
    }
    if (!this.isMobileSearchOpen) {
      this.searchText = '';
      document.querySelector('.actions-container')?.classList.add('mb-8');
    }
  }
  onEvent(event: any) {
    this.isMobileSearchOpen = false;
    this.searchText = '';
    document.querySelector('.actions-container')?.classList.add('mb-8');
  }
}
